import React from 'react';

import useBreadcrumbs from './breadcrumbs.controller';

const ID = 'breadcrumbs';

export const Breadcrumbs = () => {
    const viewProps = useBreadcrumbs();

    return (
        <nav
            id={ID}
            aria-label='breadcrumbs'
            className='flex flex-col gap-1'>
            <ol className='text-brand-secondary flex flex-wrap items-center justify-center bg-transparent p-0 md:justify-start'>{viewProps.breadcrumbs}</ol>
            <p
                className='text-brand-secondary text-lg font-medium'
                role='heading'>
                {viewProps.title}
            </p>
        </nav>
    );
};
